import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers'; // Combined reducers
import sagas from './sagas';
import {persistStore} from "redux-persist"; // Import root saga


const sagaMiddleware = createSagaMiddleware();

// Configure the store
const config = () => {
    const store = configureStore({
        reducer: {
            ...reducers,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: false,
                serializableCheck: false, // Disable serializable check for Redux Persist
            }).concat(sagaMiddleware),
    });

    sagaMiddleware.run(sagas); // Run the root saga

    return store;
}
const store = config();
// export const persistor = persistStore(store); // Create persistor

export default store;
